import FingerprintJS from '@fingerprintjs/fingerprintjs'

export async function generateDeviceFingerprint() {
    var result = await version1();
    return result;
}

async function version1() {
  
  const fpPromise = await FingerprintJS.load({
    monitoring : false
  });
  
  var result = await fpPromise.get();
  return result;
}


// WEBPACK FOOTER //
// ./src/framework/utils/device-fingerprint.js